module.exports = __webpack_public_path__ + "img/window-close.be9054c0.svg";